const { instance } = require('./url')


async function login(email, password) {
    return await instance.post('/account/login/', {
        'account':  {
            'email': email,
            'password': password,
        },
    })
}

async function createAccount(account) {
    return await instance.post('/account', {
        'account':  account,
    })
}

async function updateAccountSettings(settings) {
    return await instance.put('/account/settings', {
        'settings': settings,
    })
}

async function sendForgotPasswordEmail(email) {
    return await instance.post('/account/sendresetpasswordemail/' + email, {})
}

async function updatePassword(resetId, password) {
    return await instance.put('/account/resetpassword/' + resetId, {
        'password': password,
    })
}

async function getAsanteProjectManagers() {
    return await instance.get('/account/project_managers')
}

export {
    login, createAccount,
    sendForgotPasswordEmail,
    updateAccountSettings,
    updatePassword,
    getAsanteProjectManagers,
}
